export default __webpack_public_path__ + "static/media/README.05d41098.md";